import { z } from 'zod';
export const TransactionTypeSchema = z.enum(['WALLET_TOPUP', 'PARKING_PAYMENT', 'REFUND', 'ADJUSTMENT']);
export const PaymentProviderSchema = z.enum(['D17', 'PAYMEE', 'FLOUCI', 'MOCK']);
export const PaymentStatusSchema = z.enum(['PENDING', 'SUCCEEDED', 'FAILED', 'CANCELED']);
export const TransactionSchema = z.object({
    id: z.string(),
    userId: z.string(),
    walletId: z.string().optional(),
    type: TransactionTypeSchema,
    amountCents: z.number().int(),
    currency: z.string().default('TND'),
    provider: PaymentProviderSchema.optional(),
    providerRef: z.string().optional(),
    status: PaymentStatusSchema,
    meta: z.record(z.any()).optional(),
    createdAt: z.date(),
});
